import { Button, Tooltip } from "@material-ui/core"
import CircularProgress from "@material-ui/core/CircularProgress"
import { makeStyles } from "@material-ui/core/styles"
import React from "react"
import { DISABLE_COLOR, LIGHT_GRAY_COLOR } from "../../theme"

const Botao = (props) => {
	const classes = useStyles(props);

	const botaoCustomizado = (
		<Button
			id={props.id}
			variant="contained"
			color={props.type}
			disabled={props.disabled || props.carregando}
			className={`${classes.botao} ${props.className}`}
			onClick={props.onClick}
			size={props.tamanho}
			href={props.href}
			target={props.target}
			fullWidth={props.fullWidth}
			component={props.component}
			to={props.to}
			startIcon={props.alignIcone === "left" ? props.icone : null}
			endIcon={props.alignIcone !== "left" ? props.icone : null}
		>
			{props.titulo} {props.atalho ? props.atalho : null}
		</Button>
	);

	let botaoRetorno = botaoCustomizado;

	if (props.carregando) {
		botaoRetorno = (
			<div className={classes.wrapper}>
				{botaoCustomizado}
				<CircularProgress color="secondary" size={24} className={classes.buttonProgress} />
			</div>
		)
	}

	return props.textoTooltip ? <Tooltip classes={{ tooltip: classes.customTooltip }} title={props.textoTooltip}>{botaoRetorno}</Tooltip> : botaoRetorno;
}

const useStyles = makeStyles((theme) => ({
	botao: {
		backgroundColor: (props) => (props.type === "primary" ? "#BF43AB" : "#323172"),
		textTransform: (props) => (props.uppercase ? "uppercase" : "none"),
		"&:hover": {
			backgroundColor: (props) => (props.type === "primary" ? "#7B286E" : "#23144D"),
		},
		"&:disabled": {
			backgroundColor: DISABLE_COLOR,
			color: LIGHT_GRAY_COLOR,
		},
	},
	buttonProgress: {
		position: "absolute",
		top: "50%",
		left: "50%",
		marginTop: -12,
		marginLeft: -12,
	},
	wrapper: {
		position: "relative",
	},
	customTooltip: {
		marginTop: 0,
		marginRight: 35
	}
}))

export default Botao